<template>
  <div class="main_header">
    <div class="header_container">
      <div class="header_panel">
        <div class="header_logo">
          <img src="../assets/img/yuanjie-logo1.png" alt="" />
        </div>

        <div class="header_menu" id="header_menu">
          <el-menu 
            class="top-menu"
            ref="topMenu"
            :default-active="activePage"
            :unique-opened="true"
            :text-color="topMenuTextColor"
            :background-color="topMenuBgColor"
            :active-text-color="topMenuActiveTextColor"
            :collapse-transition="false"
            mode="horizontal"
            menu-trigger="hover">
            <div v-for="menuItem in headerList" :key="menuItem.id"> 
              <el-menu-item v-if="(menuItem.subMenuList === undefined) || (menuItem.subMenuList === undefined) || (menuItem.subMenuList.length === 0)" :index="menuItem.title">
                <p @click="go(menuItem)">{{ $parseLabel(menuItem.title) }}</p>
              </el-menu-item>
              <el-submenu v-else-if="menuItem.subMenuList.length > 0" :index="menuItem.title" popper-append-to-body>
                <template slot="title">
                  <p>
                    {{ $parseLabel(menuItem.title) }}
                  </p>
                </template>
                <template v-for="submMenuItem in menuItem.subMenuList">
                  <el-submenu
                    v-if="submMenuItem.subMenuList && submMenuItem.subMenuList.length > 0"
                    :key="`sub-${submMenuItem.id}`"
                    :index="`${menuItem.title}-${submMenuItem.title}`"
                    popper-append-to-body>
                    <template slot="title">
                      <p>{{ $parseLabel(submMenuItem.title) }}</p>
                    </template>
                    <el-menu-item
                      v-for="thirdMenuItem in submMenuItem.subMenuList"
                      :key="thirdMenuItem.id"
                      :id="thirdMenuItem.id"
                      :index="`${menuItem.title}-${submMenuItem.title}-${thirdMenuItem.title}`">
                      <p
                        @mouseenter="onMenuItemHover(thirdMenuItem.id)"
                        @mouseleave="onMenuItemBlur(thirdMenuItem.id)"
                        @click="go(thirdMenuItem)">
                        {{ $parseLabel(thirdMenuItem.title) }}
                      </p>
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :key="`leaf-${submMenuItem.id}`"
                    :id="submMenuItem.id"
                    :index="submMenuItem.title">
                    <p @mouseenter="onMenuItemHover(submMenuItem.id)" @mouseleave="onMenuItemBlur(submMenuItem.id)" @click="go(submMenuItem)">{{ $parseLabel(submMenuItem.title) }}</p>
                  </el-menu-item>
                </template>
              </el-submenu>
            </div>
          </el-menu>

        </div>

        <div class="head_right">
          <ul>
            <li>
              <el-dropdown>
                <div class="head_right_item">
                  <p :style="{'color': `${topMenuTextColor}`, 'font-size': '16px'}">
                    {{ languageList.find(item=> item.code === $i18n.locale).name }}
                  </p>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    style="min-width: 100px; text-align: center;"
                    v-for="(list, index) in languageList"
                    :key="index"
                    @click.native="onSwitchLanguage(list)"
                    >{{ list.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <!-- 新增：消息通知组件 -->
            <li>
              <message-notification :message-icon-color="topMenuTextColor" />
            </li>
            <li>
              <el-dropdown>
                <div class="head_right_item">
                  <p :style="{'color': `${topMenuTextColor}`, 'font-size': '16px', 'text-align': 'center'}">
                    {{ ((isEmpty(plantSelected) === false) && (isString(plantSelected.plantName) === true)) ? $parseLabel(plantSelected.plantName) : '' }}
                  </p>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    style="min-width: 100px; text-align: center;"
                    v-for="plantItem in plantList"
                    :key="plantItem.plantId"
                    @click.native="plantSelected = plantItem"
                    >{{ $parseLabel(plantItem.plantName) }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>
              <div class="main_user" v-if="isEmpty($store.state.userData.name) === false">
                <el-row type="flex" justify="center">
                  <div class="main_user_info">{{ $store.state.userData.name }}</div>

                  <el-dropdown style="display: flex; align-items: center;">
                    <el-row type="flex" class="head_right_item">
                      <img
                        class="main_user_avatar"
                        src="@/assets/img/avatar.gif"
                        alt=""
                      />
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-row>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item 
                        style="min-width: 100px; text-align: center;"
                        @click.native="jumpUser()"
                        >{{ $parseLabel('个人中心') }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        style="min-width: 100px; text-align: center;"
                        @click.native="doLogout()"
                        >{{ $parseLabel('退出登录') }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-row>
              </div>
              <div class="main_login" @click="login" v-else>
                <p>{{ $parseLabel('登录/注册')}}</p>              
              </div>
            </li>
          </ul>

          <div class="header_collapse" id="header_collapse">
            <div id="ccx_collapse_menu" class="collapse_menu_closed" @click="handleCollapseMenu">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

        </div>
      </div>

      <!-- 折叠式弹出菜单 -->
      <div class="collapse_dialog" v-if="showCollapseDialog === true">
        <div class="collapse_nav_container">
          <div class="collapse_nav_box">
            <ul class="collapse_nav_ul_main">
              <li v-for="menuItem in headerList" :key="menuItem.id">
                <el-row v-if="menuItem.subMenuList != undefined && menuItem.subMenuList.length > 0">
                  <el-row type="flex" justify="space-between" >
                    <el-col :span="1.5">
                      <p>{{ $parseLabel(menuItem.title) }}</p>
                    </el-col> 
                    <el-col :span="1.5">
                      <i class="el-icon-arrow-right" :class="{ arrow_rotate: isCollapseSubmenuOpen(menuItem.id) }" @click="toggleCollapseSubmenu(menuItem.id)"></i>
                    </el-col>
                  </el-row>
                  <el-row >
                    <ul class="collapse_nav_ul_sub" :key="menuItem.id" :class="{ sub_ul_show: isCollapseSubmenuOpen(menuItem.id) }">
                      <li v-for="subMenuItem in menuItem.subMenuList" :key="subMenuItem.id">
                        <template v-if="subMenuItem.subMenuList && subMenuItem.subMenuList.length > 0">
                          <el-row type="flex" justify="space-between">
                            <el-col :span="1.5">
                              <p>{{ $parseLabel(subMenuItem.title) }}</p>
                            </el-col>
                            <el-col :span="1.5">
                              <i class="el-icon-arrow-right" :class="{ arrow_rotate: isCollapseSubmenuOpen(subMenuItem.id) }" @click="toggleCollapseSubmenu(subMenuItem.id)"></i>
                            </el-col>
                          </el-row>
                          <ul class="collapse_nav_ul_sub collapse_nav_ul_sub_nested" :class="{ sub_ul_show: isCollapseSubmenuOpen(subMenuItem.id) }">
                            <li v-for="thirdMenuItem in subMenuItem.subMenuList" :key="thirdMenuItem.id">
                              <a href="javascript:void(0);" @click.once="handleCollapseMenuClicked(thirdMenuItem)">{{ $parseLabel(thirdMenuItem.title) }}</a>
                            </li>
                          </ul>
                        </template>
                        <a v-else href="javascript:void(0);" @click.once="handleCollapseMenuClicked(subMenuItem)">{{ $parseLabel(subMenuItem.title) }}</a>
                      </li>
                    </ul>
                  </el-row> 
                </el-row>
                <el-row type="flex" justify="space-between" v-else>
                  <a href="javascript:void(0);" @click.once="handleCollapseMenuClicked(menuItem)">{{ $parseLabel(menuItem.title) }}</a>
                </el-row>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div class="hasHeader"></div>

    <div class="banner_container">

      <div class="banner_panel">

        <el-carousel
          indicator-position="inside"
          :autoplay="true"
          :interval="5000"
          arrow="never"
          :loop="true"
        >
          <el-carousel-item v-for="(item, index) in carouselList" :key="index">
            <el-row class="slogan_item">
              <img class="slogan_cover" :src="item.path" alt=""/>
              <div class="ccx_mask"></div>
              <div class="slogan_title">
                <h3>{{ $parseLabel(item.title) }}</h3>
              </div>
            </el-row>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>



    <!-- <v-login :dialogVisible="dialogVisible" @outClose="dialogVisible = false" /> -->
    <el-dialog
      :title="$parseLabel('提示')"
      :visible.sync="dataDialogVisible"
      width="30%"

      :before-close="handleClose"
    >
      <span>{{ content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dataDialogVisible = false"
          >{{ $parseLabel('我已知晓') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import { Header, LangList } from "../utils/data";
//import { getLanguageList } from "@/api/list";
import { getHetPlantList, getCarouselList } from "@/api/kpi"
import { logout, updateLangCode } from '@/api/user'
import variables from "@/theme/variables.less"
import { getToken } from '@/api/auth'
// 新增：导入消息通知组件
import MessageNotification from './message/index.vue'

export default {
  components: {
    //"v-login": login,
    MessageNotification
  },
  props: {
    activePage: {
      type: String,
      require: false,
      default: ''
    }
  },
  data() {
    return {
      globalFingerprint: '',

      mCollapseMenu: undefined,
      showCollapseDialog: false,

      //dialogVisible: false,
      dataDialogVisible: false,

      carouselList: [],
      languageList: LangList,
      languageName: "",
      headerList: Header,
      content: {},

      variables,
      topMenuBgColor: '',
      topMenuActiveTextColor: '',

      plantList: [],
      plantSelected: undefined,
      collapseSubmenuState: {},

      refreshTokenTimer: undefined
    };
  },
  watch: {
    "$store.state.userData": {
      handler() {
        //this.getLanguageList();
      },
    },
    "$store.state.locale": {
      handler() {
        this.$i18n.locale = this.$store.state.locale;
      },
    }    
  },
  beforeDestroy() {
    if(this.isEmpty(this.refreshTokenTimer) === false) {
      clearInterval(this.refreshTokenTimer);
      this.refreshTokenTimer = undefined;
    }
  },
  created() {
    this.handleRefresh();

    this.initVariables();
    //this.getLanguageList();
    // this.getInfo()
    this.doGetCarouselList();

    this.$nextTick(()=>{
      if(this.mCollapseMenu === undefined) {
        this.mCollapseMenu = document.getElementById("ccx_collapse_menu");
        this.$store.commit("setCollapseMenuState", 'closed');
        this.showCollapseMenu();
      }
    });

    //确保在窗口大小大于1280时弹出式菜单是关闭的
    window.addEventListener("resize", () => {
      const innerWidth =window.innerWidth;
      if(innerWidth > this.variables.globalCollapseThreshold) {
        if(this.showCollapseDialog === true) {
          this.showCollapseDialog = false;
          this.$store.commit("setCollapseMenuState", 'closed');
          this.removeClass(this.mCollapseMenu, 'collapse_menu_opened');
          this.addClass(this.mCollapseMenu, 'collapse_menu_closed');
        }
      }
    });

    this.refreshTokenTimer = setInterval(this.handleRefresh, 300*1000);
  },
  methods: {
    initVariables() {
      var rootVar = document.querySelector(':root');
      this.topMenuBgColor = getComputedStyle(rootVar).getPropertyValue('--topMenuBgColor');
      this.topMenuTextColor = getComputedStyle(rootVar).getPropertyValue('--topMenuTextColor');
      this.topMenuActiveTextColor = getComputedStyle(rootVar).getPropertyValue('--topMenuActiveTextColor');
      this.initPlanList();
    },
    async initPlanList() {
      var _this = this;
      _this.plantSelected = undefined;
      _this.plantList = [];

      _this.plantList = this.$store.state.plantList;
      if(_this.isEmpty( _this.plantList) === false) {
        this.plantSelected = this.plantList[0]
      } else {
        await getHetPlantList().then(res => {
          //console.log("header res: ", res);
          if ((res.success === true) && (_this.isEmpty(res.data) === false)) {
            res.data.forEach(hetPlantItem => {
              _this.plantList.push({
                plantId: parseInt(hetPlantItem.value),
                plantName: hetPlantItem.label
              });
            })

            if(_this.isEmpty(_this.plantList) === false) {
              this.$store.commit("setPlantList", _this.plantList);
              _this.plantSelected = _this.plantList[0]
              //console.log("header this.plantSelected: ", _this.plantSelected);
            }
          }
        }).catch(err=>{
          _this.msgError(err);
        });
      }
    },
    doGetCarouselList(){
      var _this = this;
      getCarouselList().then(res => {
        const sourceList = (res && res.data && Array.isArray(res.data.list)) ? res.data.list : [];
        if (sourceList.length > 0 && Array.isArray(sourceList[0].pictures)) {
          // 以 mockCarouselList 返回值为准，不做二次改写
          _this.carouselList = sourceList[0].pictures;
        } else {
          _this.carouselList = [];
        }
      })
    },
    login() {
      //跳转到登录页
      this.$redirectToLogin();
    },
    go(item) {
      console.log("item: ", item)
      if(item.url) {
        if(this.isEmpty(item.type) === false) {
          if(item.type === 'router') {
            window.open(item.url,'_self')
          } else if(item.type === 'link') {
            this.$encryption(item.url, item.code)
          }
        }
      } else {
        this.msgError(this.$parseLabel('模块开发中...'))
      }
    },
    open(list) {
      this.content = list.content;
      this.dataDialogVisible = true;
    },
    doLogout() {
      let _this = this;
      this.$confirm(this.$parseLabel('确定要退出系统吗？'), this.$parseLabel('提示'), {
        confirmButtonText: this.$parseLabel('确定'),
        cancelButtonText: this.$parseLabel('取消'),
        type: 'warning'
      }).then(() => {
        logout().then((response) => {
          if(response.success === true) {
            _this.$store.commit("logout");
            _this.$router.push({
              path: "/",
            });
          }
        })
      }).catch(()=>{});
    },
    jumpUser() {
      this.$router.push({
        path: "/user",
      });
    },
    // getLanguageList() {
    //   var _this = this;
    //   this.languageList = [];
    //   getLanguageList().then((res) => {
    //     if(_this.isEmpty(res.data) === false) {
    //       res.data.forEach((item) => {
    //         _this.languageList.push({
    //           code: item.code,
    //           name: item.name
    //         });
    //       });
    //     }
    //     _this.languageName = res.data[0]["name"];
    //   });
    // },
    handleClose() {
      this.dataDialogVisible = false
    },
    onMenuItemHover(menuItemId) {
      let obj = document.getElementById(menuItemId);

      this.addClass(obj, "ccx_submenu_item_style")
    },
    onMenuItemBlur(menuItemId) {
      let obj = document.getElementById(menuItemId);

      this.removeClass(obj, "ccx_submenu_item_style")
    },
    showCollapseMenu() {
      if(this.mCollapseMenu != undefined) {
        if(this.showCollapseDialog === true) {
          this.removeClass(this.mCollapseMenu, 'collapse_menu_closed');
          this.addClass(this.mCollapseMenu, 'collapse_menu_opened');
        } else {
          this.removeClass(this.mCollapseMenu, 'collapse_menu_opened');
          this.addClass(this.mCollapseMenu, 'collapse_menu_closed');
        }
      }
    },
    handleCollapseMenu() {
      if(this.mCollapseMenu != undefined) {
        if(this.showCollapseDialog === false) {
          this.showCollapseDialog = true;
          this.collapseSubmenuState = {};
          this.$store.commit("setCollapseMenuState", 'opened');
          this.removeClass(this.mCollapseMenu, 'collapse_menu_closed');
          this.addClass(this.mCollapseMenu, 'collapse_menu_opened');
        } else {
          this.showCollapseDialog = false;
          this.$store.commit("setCollapseMenuState", 'closed');
          this.removeClass(this.mCollapseMenu, 'collapse_menu_opened');
          this.addClass(this.mCollapseMenu, 'collapse_menu_closed');
        }
      }
    },
    handleCollapseMenuClicked(item) {
      this.showCollapseDialog = false;
      this.collapseSubmenuState = {};
      this.$store.commit("setCollapseMenuState", 'closed');
      this.removeClass(this.mCollapseMenu, 'collapse_menu_opened');
      this.addClass(this.mCollapseMenu, 'collapse_menu_closed');
      this.go(item);
    },
    isCollapseSubmenuOpen(menuId) {
      return this.collapseSubmenuState[menuId] === true;
    },
    toggleCollapseSubmenu(menuId) {
      this.$set(this.collapseSubmenuState, menuId, !this.isCollapseSubmenuOpen(menuId));
    },
    async onSwitchLanguage(item) {
      this.languageName = item.name;
      this.$setLocale(item.code);

      await updateLangCode({ code: item.code }).then(response=>{
        console.log("updateLangCode response: ", response);
      }).catch((err) => {
        console.log("updateLangCode err: ", err);
      });

      //英语主菜单过长,直接折叠主菜单
      // if(this.$i18n.locale === 'en') {
      //   let mainMenuDiv = document.getElementById('header_menu');
      //   let collapseMenuDiv = document.getElementById('header_collapse');
      //   //隐藏主菜单
      //   mainMenuDiv.style.display = 'none';
      //   //显示折叠菜单
      //   collapseMenuDiv.style.display = 'block';
      // }
    },
    handleRefresh() {
      getToken().then((res) => {
        if ((res.success === false) || (res.data === null)) {
          this.$store.commit("removeAuthKey");
          this.$store.commit("removeUser");
          this.$store.commit("removeAccessToken");
        } else {
          this.$store.commit("setAccessToken", res.data);
          this.$doGetProfile();
        }
      }).catch(()=>{

      });
    }
  },
};
</script>
    
<style lang="less" scoped>
@import "~@/theme/variables.less";

.main_header {
  width: 100%;
  min-width: 1500px;
  overflow-x: hidden;

  // .el-carousel__item:nth-child(2n) {
  //   background-color: #99a9bf;
  // }
  
  .hasHeader {
    width: 100%;
    height: var(--topMenuHeight);
    line-height: var(--topMenuHeight);
  }

  .header_container {
    width: 100%;
    height: var(--topMenuHeight);
    line-height: var(--topMenuHeight);
    background-color: var(--topMenuBgColor);
    position: fixed;
    top: 0;
    z-index: 1000;
    box-shadow: var(--topMenuShadow);

    .header_panel {
      width: 92%;
      height: 100%;
      margin: auto;
      display: flex;
      justify-content: space-between;

      .header_logo {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;

        img {
          width: 150px;
        }
      }

      .header_menu {
        flex: 1;
        display: flex;
        overflow: hidden;
        transition: all 0.3s ease-in;

        ul {
          display: flex;
          margin: 0 auto;

          li {
            height: 100%;
            line-height: var(--topMenuHeight);
            list-style: none;
            // color: rgba(225, 225, 225, 0.9);
            color: #fff;
            font-size: 16px;
            margin-right: 0px;
            cursor: pointer;
            position: relative;
          }
        }
      }

      .head_right {
        //width: 200px;
        display: flex;

        ul {
          display: flex;

          li{
            width: max-content;
            height: 100%;
            margin: 0 20px 0 0;
            line-height: var(--topMenuHeight);
            list-style: none;
            color: var(--topMenuTextColor)!important;
            font-size: 16px;
            cursor: pointer;
            position: relative;
            background-color: transparent;
          }
          
          li:last-child {
            margin: 0;
          }
        }

        .head_right_item {
          height: 100%;
          line-height: 100%;
          display: flex;
          align-items: center;
          margin: 0 5px;

          cursor: pointer;
          i {
            color: #fff !important;
            display: none;
            height: 27px; 
            line-height: 27px;
          }
        }

        .main_user {
          width: max-content;
          display: flex;
          align-items: center;
          padding: 0!important;

          .main_user_info {
            max-width: 100px;
            margin: 0 5px;
            overflow: hidden;    
            text-overflow:ellipsis;    
            white-space: nowrap;
            color: var(--topMenuTextColor)!important;
          }

          .main_user_avatar {
            width: 25px;
            height: 25px;
            border: 1px solid #fff;
            border-radius: 50%;
          }

          .main_login {
            width: auto;
            height: var(--topMenuHeight);

            p {
              width: 100%;
              height: var(--topMenuHeight);
              line-height: var(--topMenuHeight);
              vertical-align: middle;
              text-align: center;
              color: var(--topMenuTextColor)!important;
            }

            p:hover {
              background-color: var(--topMenuHoverBgColor)!important;
            }
          }

          /deep/ .el-dropdown:hover {
            background-color: var(--topMenuHoverBgColor)!important;
          }
        }

        .main_user:hover {
          background-color: var(--topMenuHoverBgColor)!important;
        }
      }

      .header_collapse {
        display: none;
        transition: all 0.3s ease-out;

        .collapse_menu_closed {
          display: flex;
          align-content: center;
          justify-content: center;
          flex-wrap: wrap;
          height: 100%;
          width: 22px;

          span {
            transform: rotate(0deg);
            display: block;
            width: 100%;
            height: 2px;
            padding: 0;
            margin: 0;
            outline: none;
            margin-bottom: 5px;
            border-radius: 3px;
            background-color: #666;
            -webkit-transition: all 0.3s linear;
            transition: all 0.3s linear;
            background-color: #333333;
            transition: all 0.3s linear;
          }

          span:nth-child(2) {
            display: block;
            margin-bottom: 5;
            width: 80%;
            transition: all 0.3s linear;
          }

          span:last-child {
            margin-bottom: 0;
            transition: all 0.3s linear;
          }
        }

        .collapse_menu_opened {
          display: flex;
          align-content: center;
          justify-content: center;
          flex-wrap: wrap;
          height: 100%;
          width: 22px;

          span:nth-child(1) {
            transform: rotate(45deg);
            margin-top: 7px 0 0 0;
            transition: all 0.3s linear;
          }

          span:nth-child(2) {
            display: none;
            transition: all 0.3s linear;
          }

          span:nth-child(3) {
            transform: rotate(-45deg);
            margin: 0;
            margin: -7px 0 0 0;
            transition: all 0.3s linear;
          }

          span {
            display: block;
            width: 100%;
            height: 2px;
            padding: 0;
            margin: 0;
            outline: none;
            margin-bottom: 5px;
            border-radius: 3px;
            background-color: #666;
            -webkit-transition: all 0.3s linear;
            background-color: #333333;
            transition: all 0.3s linear;
          }
        }
      }
    }
  }

  /deep/.el-submenu__icon-arrow {
    display: none;
  }

  /deep/.el-menu-item {
    height: var(--topMenuHeight)!important;
    line-height: var(--topMenuHeight)!important;
    padding: 0 16px!important;

    p {
      height: var(--topMenuHeight)!important;
      line-height: var(--topMenuHeight)!important;
      font-size: 16px!important;
    }
  }

  /deep/.el-submenu {
    height: var(--topMenuHeight)!important;
    line-height: var(--topMenuHeight)!important;

    .el-submenu__title {
      height: var(--topMenuHeight)!important;
      line-height: var(--topMenuHeight)!important;

      p {
        height: var(--topMenuHeight)!important;
        line-height: var(--topMenuHeight)!important;
        font-size: 16px!important;
      }
    }
  }

  /deep/.top-menu {
    .el-menu-item:hover {
      box-sizing: border-box!important;
      background-color: var(--topMenuHoverBgColor)!important;

      p {
        box-sizing: border-box!important;
        background-color: var(--topMenuHoverBgColor)!important;
        color: var(--topMenuActiveTextColor) !important;
        //border-bottom: 2px solid var(--topMenuActiveTextColor)!important;
      }
    }

    .el-submenu > .el-submenu__title:hover {
      box-sizing: border-box!important;
      background-color: var(--topMenuHoverBgColor)!important;

      p {
        box-sizing: border-box!important;
        background-color: var(--topMenuHoverBgColor)!important;
        color: var(--topMenuActiveTextColor) !important;
        //border-bottom: 2px solid var(--topMenuActiveTextColor)!important;
      }
    }

    .el-submenu.is-opened > .el-submenu__title {
      box-sizing: border-box!important;
      background-color: var(--topMenuHoverBgColor)!important;

      p {
        box-sizing: border-box!important;
        background-color: var(--topMenuHoverBgColor)!important;
        color: var(--topMenuActiveTextColor) !important;
        //border-bottom: 2px solid var(--topMenuActiveTextColor)!important;
      }
    }

    /* 一级菜单被选中时,其本身处在active状态 */
    .el-menu-item.is-active {
      box-sizing: border-box!important;

      p {
        box-sizing: border-box!important;
        color: var(--topMenuActiveTextColor) !important;
        //border-bottom: 2px solid var(--topMenuActiveTextColor)!important;
      }
    }

    /* 二级菜单被选中时,其对应的一级菜单处在active状态 */
    .el-submenu.is-active > .el-submenu__title {
      box-sizing: border-box!important;

      p {
        box-sizing: border-box!important;
        color: var(--topMenuActiveTextColor) !important;
        //border-bottom: 2px solid var(--topMenuActiveTextColor)!important;
      }
    }
  }

  .banner_container {
    width: 100%;
    //height: 400px;
    height: calc(100vh - var(--topMenuHeight));
    background: transparent;
    //background: url("../assets/img/banner.jpg") no-repeat center;
    background-size: cover;
    position: relative;
    
    .banner_panel {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);

      .slogan_item {
        width: 100%;
        height: 100%;
        line-height: 1;
        margin: 0;
        padding: 0;
        position: relative;
        z-index: 1;
        
        .slogan_cover {
          width: 100%;
          height: 100%;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          object-fit: cover;
        }

        .slogan_title {
          position: absolute;
          top: 50%;
          transform: translateY(-100%);
          //垂直居中
          //transform: translateY(-50%);
          left: 120px;
          z-index: 4;

          h3 {
            height: 50px;
            line-height: 50px;
            font-size: 30px;
            color: #fff;
          }
        }

        .ccx_mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: 0.15;
          z-index: 3;
        }
      }

      /deep/.el-carousel.el-carousel--horizontal {
        height: 100%!important;
      }

      /deep/.el-carousel__container {
        height: 100%!important;
      }

      /deep/.el-carousel__arrow {
        width: auto;
        height: auto;
        padding: 15px;
        font-size: 24px;
        color: #FFFFFF;
        background-color: rgba(0, 0, 0, 0.3);
      }
      /deep/.el-carousel__button {
        height: 6px!important;
        width: 40px;
        border-radius: 6px;
      }
      /deep/.el-carousel__indicators--horizontal {
        bottom: 30px;
      }
    }
  }

  .collapse_dialog {
    width: 100%;
    height: 100vh;
    display: block;
    background-color: #FFFFFF;
    position: absolute;
    left: 0;
    top: var(--topMenuHeight);
    z-index: 999;
    transition: all .8s ease-in;
    border-top: 1px solid var(--boxBorder);

    .collapse_nav_container {
      position: relative;
      width: 90%;
      height: 100%;
      padding: 0;
      margin: 0 auto;
      overflow-x: hidden;
      overflow-y: scroll;

      .collapse_nav_box {
        width: 100%;
        height: 100%;
        line-height: 60px;
        padding: 26px 0;
      }

      .collapse_nav_ul_main {
        padding: 12px 20px;
        list-style: none;

        li {
          border-bottom: 1px solid var(--boxBorder);

          a {
            font-size: 18px;
            color: #444;
            text-decoration: none;
          }

          p {
            font-size: 18px;
            color: #444;
          }

          i {
            font-size: 18px;
            color: #444;
            transition: all .3s linear;
          }

          i.arrow_rotate {
            transform: rotate(90deg);
            transition: all .3s linear;
          }
        }
      }

      .collapse_nav_ul_sub {
        padding: 0 20px 20px 20px;
        list-style: none;
        display: none;

        li {
          border: none;
          height: 30px;
          line-height: 30px;

          a {
            font-size: 16px;
            color: #666;
            text-decoration: none;
          }

          p {
            font-size: 16px;
            color: #666;
          }
        }
      }

      .collapse_nav_ul_sub.sub_ul_show {
        display: block!important;
      }
    }
  }
}

.ccx_submenu_item_style {
  border-bottom: none!important;
  background-color: var(--topMenuHoverBgColor)!important;
  color: var(--topMenuActiveTextColor)!important;
}

@media (max-width: @globalCollapseThreshold) {
  .header_menu {
    display: none!important;
    transition: all 0.3s ease-out;
  }

  .header_collapse {
    display: block!important;
    margin-left: 20px;
    transition: all 0.3s ease-in;
  }
}
</style>
